import { STEP_IDENTIFIER_NAME } from '../constants';
import type { StepConfig } from '../types';

const { AI_ASK_CHOICE } = STEP_IDENTIFIER_NAME;

export const aiAskChoice: StepConfig = {
	name: AI_ASK_CHOICE,
	isAuthenticationRequired: false,
	isEnabled: () => true,
};
